var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaiwan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.4531C32 25.2896 24.8365 32.4531 16 32.4531C7.1635 32.4531 0 25.2896 0 16.4531C5.49563 10.9575 10.1565 6.29663 16 0.453125C24.8365 0.453125 32 7.61662 32 16.4531Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.4531C16 7.61662 16 6.57487 16 0.453125C7.1635 0.453125 0 7.61662 0 16.4531H16Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.913 9.81679L11.9589 10.736L12.9994 12.6285L10.8776 12.2225L10.6087 14.366L9.13082 12.7895L7.65282 14.366L7.38401 12.2225L5.26213 12.6284L6.30263 10.7359L4.34863 9.81679L6.3027 8.89773L5.26213 7.00523L7.38394 7.41117L7.65288 5.26767L9.13082 6.84417L10.6088 5.26767L10.8776 7.41117L12.9995 7.00523L11.9589 8.89779L13.913 9.81679Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1309 12.7949C10.7758 12.7949 12.1092 11.4614 12.1092 9.81654C12.1092 8.17167 10.7758 6.83823 9.1309 6.83823C7.48603 6.83823 6.15259 8.17167 6.15259 9.81654C6.15259 11.4614 7.48603 12.7949 9.1309 12.7949Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13088 11.4042C8.25582 11.4042 7.54395 10.6923 7.54395 9.81721C7.54395 8.94215 8.25588 8.23021 9.13088 8.23021C10.0059 8.23021 10.7179 8.94215 10.7179 9.81721C10.7178 10.6923 10.0058 11.4042 9.13088 11.4042Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.453125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaiwan);
export default __webpack_public_path__ + "static/media/taiwan.092142db.svg";
export { ForwardRef as ReactComponent };